<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.2558 20.4939L9.83429 19.0676C9.42954 18.6614 8.88078 18.434 8.30867 18.434H7.24035C5.06478 18.434 3.30078 16.664 3.30078 14.4811V7.54177C3.30078 5.35884 5.06478 3.58984 7.24035 3.58984H17.3622C19.5378 3.58984 21.3008 5.35884 21.3008 7.54177V14.4811C21.3008 16.664 19.5378 18.434 17.3622 18.434H16.2939C15.7218 18.434 15.173 18.6614 14.7682 19.0676L13.3458 20.4939C12.7688 21.0738 11.8338 21.0738 11.2558 20.4939Z"
      stroke="#A3A3A3"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M9.10938 12.707H12.7716"
      stroke="#A3A3A3"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M9.10938 8.88281H15.4921"
      stroke="#A3A3A3"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
